import { api } from './api';
import type { LeaderboardEntry, HeatmapData, TimeseriesPoint } from '../types';

export const strategyDashboardApi = {
  leaderboard: () =>
    api.get<LeaderboardEntry[]>('/strategy-dashboard/leaderboard'),

  heatmap: () =>
    api.get<HeatmapData[]>('/strategy-dashboard/heatmap'),

  timeseries: (strategyId?: number, days = 30) =>
    api.get<TimeseriesPoint[] | Record<number, TimeseriesPoint[]>>(
      `/strategy-dashboard/timeseries${strategyId ? `?strategy_id=${strategyId}&days=${days}` : `?days=${days}`}`
    ),
};
